import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { StripePaymentMethodsResponse } from "../../models/payment-gateway-responses.interface";

/**
 * Stripe payment gateway service
 * Handles API calls to Stripe for payment method retrieval
 */
@Injectable({
  providedIn: "root",
})
export class StripeService {
  private serviceRoot = "https://api.stripe.com/v1/";

  constructor(private http: HttpClient) {}

  /**
   * Get customer payment methods from Stripe
   * Matches old QMC stripe.service.ts:16-19
   * @param customerProfileId Stripe customer ID
   * @param apiKey Stripe API key (secret key)
   * @returns Observable of Stripe payment methods response
   */
  getCustomerInformation(
    customerProfileId: string,
    apiKey: string,
  ): Observable<StripePaymentMethodsResponse> {
    const endpoint = `${this.serviceRoot}customers/${customerProfileId}/payment_methods`;

    const headers = this.createHeaders(apiKey);

    return this.http.get<StripePaymentMethodsResponse>(endpoint, { headers });
  }

  /**
   * Create HTTP headers with Stripe authentication
   * Matches old QMC stripe.service.ts:32-36
   * @param apiKey Stripe API key
   * @returns HTTP headers
   */
  private createHeaders(apiKey: string): HttpHeaders {
    // Stripe uses Bearer token authentication
    return new HttpHeaders({
      Authorization: `Bearer ${apiKey}`,
    });
  }
}
